(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lift-article-main"]) return;
  try {
    
  /* Retoques al cuerpo del artículo (contenido del editor de Shopify). Sin esto el artículo se lee igual.
     1) Los titulares sin texto que deja el editor (<h4><br></h4>, <h2></h2>) se quitan: no dejan hueco,
        no se anuncian como titular y el bloque siguiente recupera su separación normal.
     2) Un iframe que no es de vídeo y trae altura por atributo (un formulario, un mapa, un cuestionario)
        la conserva: la base pone todos los iframes a 16:9.
     3) Una tabla que no cabe y se desplaza en horizontal (móvil) recibe foco con el teclado. */
  (function () {
    var VIDEO = /youtube(-nocookie)?\.com|youtu\.be|vimeo\.com|wistia\.|loom\.com|dailymotion\.com/i;

    function tidy(root) {
      var scope = root && root.querySelectorAll ? root : document;
      Array.prototype.forEach.call(scope.querySelectorAll('.lift-article__body'), function (body) {
        Array.prototype.forEach.call(body.querySelectorAll('h2, h3, h4, h5, h6'), function (heading) {
          if (!heading.id && !heading.textContent.trim() && !heading.querySelector('img, svg, video, iframe, [id], [name]')) heading.remove();
        });
        Array.prototype.forEach.call(body.querySelectorAll('iframe[height]'), function (frame) {
          var height = frame.getAttribute('height');
          if (frame.style.height || !/^\d+$/.test(height) || VIDEO.test(frame.getAttribute('src') || '')) return;
          frame.style.height = height + 'px';
          frame.style.aspectRatio = 'auto';
        });
        Array.prototype.forEach.call(body.querySelectorAll('table'), function (table) {
          if (table.scrollWidth > table.clientWidth + 1 && !table.hasAttribute('tabindex')) table.tabIndex = 0;
        });
      });
    }

    tidy();
    document.addEventListener('shopify:section:load', function (event) {
      tidy(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lift-cta-form"] && !Shopify.designMode) return;
  try {
    
  /* Tras enviar el formulario, lleva el foco al mensaje de éxito o de error para que lo lean los lectores de pantalla. */
  (function () {
    function focusStatus(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var nodes = scope.querySelectorAll('.lift-cta-form [data-lift-form-status]');
      if (!nodes.length || nodes[0].getAttribute('data-focused')) return;
      nodes[0].setAttribute('data-focused', 'true');
      try {
        nodes[0].focus();
      } catch (e) {}
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        focusStatus(document);
      });
    } else {
      focusStatus(document);
    }
    document.addEventListener('shopify:section:load', function (event) {
      focusStatus(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lift-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Editor de temas: al elegir una pregunta en la barra lateral, se abre. */
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (el && el.classList && el.classList.contains('lift-faq__item')) el.open = true;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lift-logos"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Editor de temas: al elegir un logotipo la marquesina se para para poder verlo y editarlo. Delegado en document,
     así sirve también para las secciones que el editor vuelve a pintar. */
  function editing(e, on) {
    var root = e.target && e.target.closest ? e.target.closest('[data-llm]') : null;
    if (root) root.classList.toggle('is-editing', on);
  }
  document.addEventListener('shopify:block:select', function (e) { editing(e, true); });
  document.addEventListener('shopify:block:deselect', function (e) { editing(e, false); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lift-page-main"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Retoques al contenido de la página (HTML del editor de Shopify), los mismos que recibe el cuerpo de un artículo.
     Sin esto la página se lee igual.
     1) Los titulares sin texto que deja el editor (<h4><br></h4>, <h2></h2>) se quitan: no dejan hueco, no se
        anuncian como titular y el bloque siguiente recupera su separación normal.
     2) Un iframe que no es de vídeo y trae altura por atributo (un formulario, un mapa) la conserva: la base pone
        todos los iframes a 16:9.
     3) Cada tabla se envuelve en una caja con desplazamiento horizontal. Si la tabla de verdad desborda, la caja
        se puede enfocar y desplazar con el teclado. */
  var VIDEO = /youtube(-nocookie)?\.com|youtu\.be|vimeo\.com|wistia\.|loom\.com|dailymotion\.com/i;

  function medir(caja) {
    var desborda = caja.scrollWidth > caja.clientWidth + 1;
    if (desborda) {
      caja.setAttribute('tabindex', '0');
      caja.setAttribute('role', 'region');
      caja.setAttribute('aria-label', 'Tabla: desplázala en horizontal para verla completa');
    } else {
      caja.removeAttribute('tabindex');
      caja.removeAttribute('role');
      caja.removeAttribute('aria-label');
    }
  }
  var observador = 'ResizeObserver' in window
    ? new ResizeObserver(function (entradas) { entradas.forEach(function (e) { medir(e.target); }); })
    : null;

  function iniciar(raiz) {
    var bloques = (raiz && raiz.querySelectorAll ? raiz : document).querySelectorAll('.lift-pm__content.lift-prose');
    Array.prototype.forEach.call(bloques, function (bloque) {
      Array.prototype.forEach.call(bloque.querySelectorAll('h2, h3, h4, h5, h6'), function (titular) {
        if (!titular.id && !titular.textContent.trim() && !titular.querySelector('img, svg, video, iframe, [id], [name]')) titular.remove();
      });
      Array.prototype.forEach.call(bloque.querySelectorAll('iframe[height]'), function (marco) {
        var alto = marco.getAttribute('height');
        if (marco.style.height || !/^\d+$/.test(alto) || VIDEO.test(marco.getAttribute('src') || '')) return;
        marco.style.height = alto + 'px';
        marco.style.aspectRatio = 'auto';
      });
      Array.prototype.forEach.call(bloque.querySelectorAll('table'), function (tabla) {
        var padre = tabla.parentNode;
        if (!padre || padre.classList.contains('lift-pm__scroll')) return;
        if (padre.closest && padre.closest('table')) return; /* tabla dentro de otra tabla */
        var caja = document.createElement('div');
        caja.className = 'lift-pm__scroll';
        padre.insertBefore(caja, tabla);
        caja.appendChild(tabla);
        medir(caja);
        if (observador) observador.observe(caja);
      });
      bloque.classList.add('is-ready');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciar(); });
  else iniciar();
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lift-project-detail"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.getAttribute('data-lpd-ready')) return;
    root.setAttribute('data-lpd-ready', '1');

    var dialog = root.querySelector('[data-lpd-dialog]');
    var links = Array.prototype.slice.call(root.querySelectorAll('[data-lpd-zoom]'));
    if (!dialog || !links.length || typeof dialog.showModal !== 'function') return;

    var stage = dialog.querySelector('[data-lpd-stage]');
    var count = dialog.querySelector('[data-lpd-count]');
    var prev = dialog.querySelector('[data-lpd-prev]');
    var next = dialog.querySelector('[data-lpd-next]');
    var close = dialog.querySelector('[data-lpd-close]');
    var zoom = dialog.querySelector('[data-lpd-zoom-toggle]');
    var index = 0;
    var locked = null; /* estilos de la raíz mientras la ventana está abierta */
    if (!stage) return;

    /* Con la ventana abierta la página de fondo no se desplaza (igual que en los casos de la portada). */
    function lock() {
      if (locked) return;
      var page = document.documentElement;
      var gap = window.innerWidth - page.clientWidth;
      locked = { overflow: page.style.overflow, padding: page.style.paddingRight };
      page.style.overflow = 'hidden';
      if (gap > 0) page.style.paddingRight = gap + 'px';
    }
    function unlock() {
      if (!locked) return;
      var page = document.documentElement;
      page.style.overflow = locked.overflow;
      page.style.paddingRight = locked.padding;
      locked = null;
    }

    /* Acercar: la imagen pasa a 2,5 veces el ancho con que se ve (900 px como mínimo, nunca más que el
       archivo) y se recorre con scroll dentro de la ventana. Si no ganaría al menos un 30 %, no se ofrece. */
    function zoomWidth(image) {
      var shown = image.getBoundingClientRect().width;
      var full = Number(links[index].getAttribute('data-width')) || image.naturalWidth || shown;
      var target = Math.min(full, Math.max(shown * 2.5, 900));
      return shown > 0 && target >= shown * 1.3 ? Math.round(target) : 0;
    }
    function setZoom(on) {
      var image = stage.querySelector('img');
      if (!image) return;
      var width = 0;
      if (on) {
        image.style.width = '';
        dialog.classList.remove('lpd-lightbox--zoom');
        width = zoomWidth(image);
      }
      image.style.width = width ? width + 'px' : '';
      dialog.classList.toggle('lpd-lightbox--zoom', !!width);
      if (zoom) {
        zoom.setAttribute('aria-pressed', width ? 'true' : 'false');
        zoom.setAttribute('aria-label', zoom.getAttribute(width ? 'data-label-out' : 'data-label-in'));
      }
      if (width) dialog.scrollLeft = Math.max(0, (dialog.scrollWidth - dialog.clientWidth) / 2);
    }
    function refreshZoom() {
      var image = stage.querySelector('img');
      if (!image) return;
      var can = zoomWidth(image) > 0;
      image.classList.toggle('lpd-lightbox__img--zoomable', can);
      if (zoom) zoom.hidden = !can;
    }

    /* La imagen ampliada se crea al abrir: así el marcado no lleva un <img> sin origen. */
    function show(position) {
      index = (position + links.length) % links.length;
      var link = links[index];
      var thumb = link.querySelector('img');
      var image = document.createElement('img');
      image.className = 'lpd-lightbox__img';
      image.alt = thumb ? thumb.alt : '';
      if (link.getAttribute('data-width')) image.width = Number(link.getAttribute('data-width'));
      if (link.getAttribute('data-height')) image.height = Number(link.getAttribute('data-height'));
      image.src = link.href;
      image.addEventListener('click', function () {
        if (image.classList.contains('lpd-lightbox__img--zoomable')) setZoom(!dialog.classList.contains('lpd-lightbox--zoom'));
      });
      /* Una apaisada no tiene ancho hasta que carga: entonces se decide si se ofrece acercarla. */
      image.addEventListener('load', function () {
        if (image.parentNode === stage && !dialog.classList.contains('lpd-lightbox--zoom')) refreshZoom();
      });
      dialog.classList.remove('lpd-lightbox--zoom');
      dialog.classList.toggle('lpd-lightbox--fit', image.width >= image.height);
      stage.textContent = '';
      stage.appendChild(image);
      if (count) count.textContent = (index + 1) + ' / ' + links.length;
      if (zoom) {
        zoom.setAttribute('aria-pressed', 'false');
        zoom.setAttribute('aria-label', zoom.getAttribute('data-label-in'));
      }
      dialog.scrollTop = 0;
      dialog.scrollLeft = 0;
      refreshZoom();
    }

    links.forEach(function (link, position) {
      link.addEventListener('click', function (event) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) return;
        event.preventDefault();
        if (!dialog.open) {
          dialog.showModal();
          lock();
        }
        show(position);
      });
    });
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    if (close) close.addEventListener('click', function () { dialog.close(); });
    if (zoom) zoom.addEventListener('click', function () { setZoom(zoom.getAttribute('aria-pressed') !== 'true'); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('keydown', function (event) {
      if (links.length < 2) return;
      if (event.key === 'ArrowLeft') show(index - 1);
      if (event.key === 'ArrowRight') show(index + 1);
    });
    dialog.addEventListener('close', function () {
      stage.textContent = '';
      dialog.classList.remove('lpd-lightbox--zoom');
      unlock();
    });
    /* Editor de temas: si la sección se vuelve a pintar con la ventana abierta, no llega el evento "close". */
    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target && event.target.contains && event.target.contains(dialog)) unlock();
    });
  }

  function scan(scope) {
    var roots = (scope && scope.querySelectorAll ? scope : document).querySelectorAll('[data-lift-project-detail]');
    Array.prototype.forEach.call(roots, init);
  }

  scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lift-project-list"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.getAttribute('data-lpl-ready')) return;
    root.setAttribute('data-lpl-ready', '1');

    var bar = root.querySelector('[data-lpl-filters]');
    if (!bar) return;
    var buttons = Array.prototype.slice.call(bar.querySelectorAll('[data-lpl-filter]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-lpl-item]'));
    var status = root.querySelector('[data-lpl-status]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    bar.addEventListener('click', function (event) {
      var button = event.target.closest ? event.target.closest('[data-lpl-filter]') : null;
      if (!button || !bar.contains(button)) return;

      var value = button.getAttribute('data-lpl-filter');
      var visible = 0;
      /* En móvil la fila de botones se desliza: el elegido queda centrado y a la vista. */
      if (bar.scrollWidth > bar.clientWidth && button.scrollIntoView) {
        button.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      }
      buttons.forEach(function (other) {
        other.setAttribute('aria-pressed', other === button ? 'true' : 'false');
      });
      items.forEach(function (item) {
        var cats = (item.getAttribute('data-cats') || '').split('||');
        var show = !value || cats.indexOf(value) > -1;
        item.hidden = !show;
        if (show) visible += 1;
      });
      if (status) {
        var text = visible === 1 ? status.getAttribute('data-one') : status.getAttribute('data-many');
        status.textContent = (text || '').replace('[n]', visible);
      }
    });
  }

  function scan(scope) {
    var roots = (scope && scope.querySelectorAll ? scope : document).querySelectorAll('[data-lift-project-list]');
    Array.prototype.forEach.call(roots, init);
  }

  scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lift-projects"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SEL = 'dialog.lpj-dialog';
  var active = null;   /* { dialog, opener, overflow, padding } mientras hay un caso abierto */
  var reopenId = null; /* editor de temas: caso que estaba abierto cuando la sección se volvió a pintar */
  var downOnBackdrop = false;

  function lock(state) {
    var root = document.documentElement;
    var gap = window.innerWidth - root.clientWidth;
    state.overflow = root.style.overflow;
    state.padding = root.style.paddingRight;
    root.style.overflow = 'hidden';
    if (gap > 0) root.style.paddingRight = gap + 'px';
  }
  function unlock(state) {
    var root = document.documentElement;
    root.style.overflow = state.overflow;
    root.style.paddingRight = state.padding;
  }
  function open(dialog, opener) {
    if (!dialog || dialog.open || typeof dialog.showModal !== 'function') return;
    if (active) {
      var previous = active.dialog;
      release(false);
      previous.close();
    }
    dialog.showModal();
    var panel = dialog.querySelector('.lpj-dialog__panel');
    if (panel) panel.scrollTop = 0;
    active = { dialog: dialog, opener: opener || null };
    lock(active);
    reopenId = dialog.id;
  }
  function release(restoreFocus) {
    if (!active) return;
    var opener = active.opener;
    unlock(active);
    active = null;
    if (restoreFocus && opener && document.contains(opener)) opener.focus({ preventScroll: true });
  }
  function matches(el, selector) { return !!(el && el.matches && el.matches(selector)); }

  document.addEventListener('mousedown', function (e) { downOnBackdrop = matches(e.target, SEL); }, true);
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var opener = target.closest('[data-lpj-open]');
    if (opener) {
      open(document.getElementById(opener.getAttribute('data-lpj-open')), opener);
      return;
    }
    var dialog = target.closest(SEL);
    if (!dialog || !dialog.open) return;
    /* Clic fuera: el diálogo no tiene relleno, así que un clic cuyo destino es el propio <dialog> cayó en el fondo. */
    if (target.closest('[data-lpj-close]') || (target === dialog && downOnBackdrop)) {
      reopenId = null;
      dialog.close();
    }
  });
  /* "cancel" (Escape) y "close" no burbujean: se escuchan en la fase de captura. */
  document.addEventListener('cancel', function (e) { if (matches(e.target, SEL)) reopenId = null; }, true);
  document.addEventListener('close', function (e) {
    if (active && e.target === active.dialog) release(true);
  }, true);

  /* Editor de temas: al volver a pintar la sección el diálogo abierto desaparece sin evento "close". */
  document.addEventListener('shopify:section:unload', function (e) {
    if (active && e.target.contains(active.dialog)) release(false);
  });
  document.addEventListener('shopify:section:load', function (e) {
    if (!reopenId || !window.Shopify || !window.Shopify.designMode) return;
    var dialog = document.getElementById(reopenId);
    if (dialog && e.target.contains(dialog)) open(dialog, e.target.querySelector('[data-lpj-open="' + reopenId + '"]'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lift-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  var store = new WeakMap();
  var motion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced() { return !!(motion && motion.matches); }
  function designMode() { return !!(window.Shopify && window.Shopify.designMode); }

  function setup(root) {
    if (store.has(root)) return;
    var viewport = root.querySelector('[data-lts-viewport]');
    var dotsBox = root.querySelector('[data-lts-dots]');
    if (!viewport) return;
    var slides = Array.prototype.slice.call(viewport.querySelectorAll('[data-lts-slide]'));
    var dotLabel = root.getAttribute('data-dot-label') || '';
    var interval = Math.max(3, parseFloat(root.getAttribute('data-interval')) || 6) * 1000;
    var wantsAutoplay = root.getAttribute('data-autoplay') === 'true' && !designMode();
    var st = { positions: [], dots: [], index: 0, timer: 0, raf: 0, stopped: false, hover: false, focus: false, touching: false, visible: false, touchX: 0, ro: null, io: null, destroy: null };

    /* Posiciones de scroll posibles: el inicio de cada tarjeta, hasta el tope del scroll. Con 3 tarjetas que caben
       enteras no hay ninguna (ni puntos); en móvil hay una por tarjeta. */
    function measure() {
      var max = viewport.scrollWidth - viewport.clientWidth;
      var base = slides.length ? slides[0].offsetLeft : 0;
      var positions = [];
      if (max > 1) {
        slides.forEach(function (slide) {
          var x = Math.min(slide.offsetLeft - base, max);
          if (!positions.length || x - positions[positions.length - 1] > 2) positions.push(x);
        });
      }
      st.positions = positions;
      if (positions.length > 1) viewport.setAttribute('tabindex', '0');
      else viewport.removeAttribute('tabindex');
      if (dotsBox && positions.length !== st.dots.length) {
        dotsBox.textContent = '';
        st.dots = positions.length > 1 ? positions.map(function (x, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'lts-dot';
          dot.setAttribute('aria-label', (dotLabel + ' ' + (i + 1) + ' de ' + positions.length).trim());
          dot.addEventListener('click', function () { stop(); go(i); });
          dotsBox.appendChild(dot);
          return dot;
        }) : [];
        dotsBox.hidden = positions.length < 2;
      }
      update();
      sync();
    }
    function update() {
      var x = viewport.scrollLeft, best = 0, distance = Infinity;
      st.positions.forEach(function (p, i) {
        var d = Math.abs(p - x);
        if (d < distance) { distance = d; best = i; }
      });
      st.index = best;
      st.dots.forEach(function (dot, i) {
        if (i === best) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
    function go(i) {
      if (!st.positions.length) return;
      i = Math.max(0, Math.min(i, st.positions.length - 1));
      viewport.scrollTo({ left: st.positions[i], behavior: reduced() ? 'auto' : 'smooth' });
    }

    /* Avance automático: solo a la vista, con la pestaña activa, sin cursor ni foco encima, y nunca con "reducir movimiento". */
    function canPlay() {
      return wantsAutoplay && !st.stopped && !reduced() && st.positions.length > 1 && st.visible && !document.hidden && !st.hover && !st.focus && !st.touching;
    }
    /* Cada posición dura lo que se tarda en leerla: unos 330 ms por palabra de las tarjetas que se ven enteras,
       con el ajuste de la sección como mínimo y 45 s como tope. Una cita de cien palabras no pasa a los seis segundos. */
    function delay() {
      var words = 0;
      if (slides.length && st.positions.length) {
        var base = slides[0].offsetLeft, from = st.positions[st.index] || 0, to = from + viewport.clientWidth;
        slides.forEach(function (slide) {
          var x = slide.offsetLeft - base;
          if (x >= from - 2 && x + slide.offsetWidth <= to + 2) words += (slide.textContent || '').trim().split(/\s+/).length;
        });
      }
      return Math.max(interval, Math.min(words * 330, 45000));
    }
    function tick() {
      st.timer = 0;
      if (!canPlay()) return;
      var next = st.index >= st.positions.length - 1 ? 0 : st.index + 1;
      go(next);
      st.index = next; /* el evento de scroll lo confirma; hace falta ya para calcular la espera siguiente */
      sync();
    }
    function sync() {
      var play = canPlay();
      if (play && !st.timer) {
        st.timer = window.setTimeout(tick, delay());
      } else if (!play && st.timer) {
        window.clearTimeout(st.timer);
        st.timer = 0;
      }
    }
    function stop() { st.stopped = true; sync(); }

    function onScroll() {
      if (st.raf) return;
      st.raf = window.requestAnimationFrame(function () { st.raf = 0; update(); });
    }
    function onKey(e) {
      if (st.positions.length < 2 || e.target !== viewport) return;
      var to = null;
      if (e.key === 'ArrowRight') to = st.index + 1;
      else if (e.key === 'ArrowLeft') to = st.index - 1;
      else if (e.key === 'Home') to = 0;
      else if (e.key === 'End') to = st.positions.length - 1;
      if (to === null) return;
      e.preventDefault();
      stop();
      go(to);
    }
    function onEnter() { st.hover = true; sync(); }
    function onLeave() { st.hover = false; sync(); }
    function onFocusIn() { st.focus = true; sync(); }
    function onFocusOut(e) { if (!root.contains(e.relatedTarget)) { st.focus = false; sync(); } }
    function onTouchStart() { st.touching = true; st.touchX = viewport.scrollLeft; sync(); }
    function onTouchEnd() {
      st.touching = false;
      if (Math.abs(viewport.scrollLeft - st.touchX) > 8) st.stopped = true; /* la persona deslizó el carrusel */
      sync();
    }
    function onWheel(e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) stop(); }
    function onVisibility() { sync(); }
    function onResize() { measure(); }

    viewport.addEventListener('scroll', onScroll, { passive: true });
    viewport.addEventListener('keydown', onKey);
    viewport.addEventListener('touchstart', onTouchStart, { passive: true });
    viewport.addEventListener('touchend', onTouchEnd, { passive: true });
    viewport.addEventListener('touchcancel', onTouchEnd, { passive: true });
    viewport.addEventListener('wheel', onWheel, { passive: true });
    root.addEventListener('mouseenter', onEnter);
    root.addEventListener('mouseleave', onLeave);
    root.addEventListener('focusin', onFocusIn);
    root.addEventListener('focusout', onFocusOut);
    document.addEventListener('visibilitychange', onVisibility);
    if (motion && motion.addEventListener) motion.addEventListener('change', onVisibility);
    if ('ResizeObserver' in window) { st.ro = new ResizeObserver(onResize); st.ro.observe(viewport); }
    else window.addEventListener('resize', onResize);
    if ('IntersectionObserver' in window) {
      st.io = new IntersectionObserver(function (entries) { st.visible = entries[entries.length - 1].isIntersecting; sync(); }, { threshold: 0.25 });
      st.io.observe(viewport);
    } else {
      st.visible = true;
    }

    st.go = function (slide) {
      var base = slides.length ? slides[0].offsetLeft : 0;
      stop();
      viewport.scrollTo({ left: Math.max(0, slide.offsetLeft - base), behavior: 'auto' });
    };
    st.destroy = function () {
      if (st.timer) window.clearTimeout(st.timer);
      if (st.raf) window.cancelAnimationFrame(st.raf);
      if (st.ro) st.ro.disconnect(); else window.removeEventListener('resize', onResize);
      if (st.io) st.io.disconnect();
      document.removeEventListener('visibilitychange', onVisibility);
      if (motion && motion.removeEventListener) motion.removeEventListener('change', onVisibility);
    };
    store.set(root, st);
    measure();
  }

  function init(scope) {
    var list = (scope && scope.querySelectorAll ? scope : document).querySelectorAll('[data-lts]');
    Array.prototype.forEach.call(list, setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  /* Editor de temas: la sección se vuelve a pintar sin recargar la página. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-lts]'), function (root) {
      var st = store.get(root);
      if (st) { st.destroy(); store.delete(root); }
    });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target && e.target.closest ? e.target.closest('[data-lts-slide]') : null;
    var root = slide ? slide.closest('[data-lts]') : null;
    var st = root ? store.get(root) : null;
    if (st) st.go(slide);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
